module.exports = __webpack_public_path__ + "image-big_sale.png";